import { render, staticRenderFns } from "./industrialPark.vue?vue&type=template&id=68f2cf1e&"
import script from "./industrialPark.vue?vue&type=script&lang=js&"
export * from "./industrialPark.vue?vue&type=script&lang=js&"
import style0 from "./industrialPark.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports